export default __webpack_public_path__ + "static/media/portada_FrankAgraz_ENG.0d82c060.jpg";